import styled from "styled-components";
import { Atom } from 'AppReact';

const ArrowImage = styled.div`
  width: 12px;
  height: 18px;
  cursor: pointer;
  margin-left: 8px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export default Atom({ type: 'label', dataType: 'object', template: ArrowImage })